const Footer = () => {
  return (
    <div className="footer">
      <div className="card text-center">
        <div className="card-footer text-muted">Ⓒ CyWeather 2022</div>
      </div>
    </div>
  );
};

export default Footer;
